import React from "react";
var __jsx = React.createElement;
import FinanceQualified from "@/pages/finance-eligibility/FinanceQualified";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FinanceQualifiedPost from "@/pages/finance-eligibility/FinanceQualifiedPost";
import Stepper from "./components/stepper/Stepper";
import { getAndClearTrackingReferralParams } from "@hooks/useHashToLocalStoreEvent";
var FinanceEligibility = function FinanceEligibility() {
  var _useState = useState(null),
    eligibilityData = _useState[0],
    setEligibilityData = _useState[1];
  var _useLocation = useLocation(),
    search = _useLocation.search;
  var navigate = useNavigate();
  var hashObject = getAndClearTrackingReferralParams(true, 'eligibility');
  var condition_id = new URLSearchParams(search).get("condition_id");
  var post_id = new URLSearchParams(search).get("post_id");
  var reset_eligibility = new URLSearchParams(search).get("reset_eligibility");
  useEffect(function () {
    if (!__IS_CSR__) {
      return;
    }
    if (reset_eligibility === 'true') {
      // Clear storage
      sessionStorage.removeItem("eligibility_data");
      sessionStorage.removeItem("finance_apply_data");

      // Remove reset_eligibility from URL
      var searchParams = new URLSearchParams(search);
      searchParams["delete"]('reset_eligibility');

      // Update URL without the reset parameter
      var newSearch = searchParams.toString();
      navigate({
        search: newSearch ? "?".concat(newSearch) : ''
      }, {
        replace: true
      });
      return;
    }
    var eligibilityData = JSON.parse(sessionStorage.getItem("eligibility_data") || null);
    setEligibilityData(eligibilityData);
  }, [search, navigate]);
  if (post_id && eligibilityData) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FinanceQualifiedPost, {
      post_id: post_id
    }));
  } else if (eligibilityData) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FinanceQualified, {
      posts_data: eligibilityData.posts_data,
      filters: eligibilityData.filters
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Stepper, {
      condition_id: condition_id
    }));
  }
};
export default FinanceEligibility;